/**
 * HTTP status off a failed RPC. The modular client throws `ClientError`, which
 * carries it as `statusCode`; axios-shaped and `RpcError` throws use `status`.
 */
export function errorStatus(error: unknown): number | undefined {
  const candidate = error as
    | { statusCode?: unknown; status?: unknown }
    | null
    | undefined;
  const status =
    typeof candidate?.statusCode === "number"
      ? candidate.statusCode
      : candidate?.status;
  return typeof status === "number" ? status : undefined;
}
